import setUserSign from '@/plugin/userSign'
import fetch from '@/plugin/axios/fetch'// 为什么调用不到this.$fetch
export const getQueryMailDetail = async params => {
  const { data } = await fetch.post({
    // url: '/mailquery/api/mailflowCust/queryMail',
    url: '/mailflowCust/queryMail',
    data: params,
    headers: {
      'USER-SIGN': setUserSign('/mailflowCust/queryMail', params)
    },
    loading: true
  })
  return data
}
